import React, { useEffect } from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import LegalMatterCard from '../../../components/Cards/LegalMatterCard';
import CategorySelector from '../../../components/Cards/CategorySelector';
import IndexesFromLegalMatters from '../../../components/Cards/IndexesFromLegalMatters';
import HistoryStatesArrows from '../../../components/HistoryStateArrows';
import LegalUsersBox from '../../../components/LegalUsersBox';
import { LAWYERS } from '../../../utils/topLegalMembers';
import { getLegalMattersByFilter, getLegalMattersById } from '../../../store/actions/LegalMatterActions';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import * as ROUTES from '../../../routes';
import { connect } from 'react-redux';
import Youtube from 'react-youtube';
import { useHistory, useRouteMatch, useParams } from 'react-router-dom';
import './LegalMatterSection.scss';
const Scroll = require('react-scroll');
const scroller = Scroll.scroller;
const ElementScroll = Scroll.Element;

const useStyles = makeStyles({
    grid: {
        display:'flex',
        flexWrap: 'wrap',
        '@media screen and (max-width: 768.98px)': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }
    },
    item: {
        width: 264,
        margin: '0 24px 24px 0',
        //height: 'fit-content',
        height: 232,
        '@media screen and (max-width: 768.98px)': {
            width: 328,
            margin: '0 0 24px',
        }
    },
    youtube: {
        height: 455,
        '@media screen and (max-width: 1109.98px)': {
            height: 195,
        },
        '@media screen and (max-width: 768.98px)': {
            height: 455,
        },
        '@media screen and (max-width: 499.98px)': {
            height: 195,
        }
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
    },
})

const LegalMattersSection = ({
    page,
    setPage,
    didRender,
    setDidRender,
    dataToFetch,
    setDataToFetch,
    legalMatterDetail,
    getLegalMattersByFilter,
    getLegalMattersById,
    legalMatterListByFilter,
    showLoading,
    hideLoading,
}) => {

    const isLegalMatter = useRouteMatch('/asuntos-legales')
    const isMobile = useMediaQuery('(max-width: 768.98px)')
    const history = useHistory()
    const params = useParams()

    useEffect(() => {
        // Muestra todos
        if (!didRender && isLegalMatter.isExact) {
            showLoading()
            getLegalMattersByFilter({ page: 1 });
            hideLoading()
            setDidRender(true)
        }

        // Ver todos los que matcheen con la especialidad
        if (didRender === false &&
            params.speciality
        ) {
            showLoading()
            getLegalMattersByFilter({ page: 1, specialty: params.speciality })
            setDataToFetch({
                category: params.speciality,
                title: ''
            })
            hideLoading()
            setDidRender(true)
        }

        // Ver la guía que matchea con el id
        if (didRender === false &&
            params.id
        ) {
            showLoading()
            const stateOfCountry = localStorage.getItem('stateOfCountry')
            let requestParams = { id: params.id }
            if (stateOfCountry) {
                requestParams['state'] = stateOfCountry
            }
            handleGetLegalMatter(requestParams)
            hideLoading()
            setDidRender(true)
        }
    }, [didRender, getLegalMattersByFilter, hideLoading, isLegalMatter, legalMatterDetail, params, params.speciality, setDataToFetch, setDidRender, showLoading])

    const opts = {
        width: '100%',
        marginBottom: '0',
        playerVars: {
          autoplay: 0,
        },
    }

    const classes = useStyles()

    const handleGetLegalMatter = async (requestParams) => {
        try {
            const newData = await getLegalMattersById(requestParams)
            setDataToFetch({
                category: params.speciality,
                title: newData &&
                    newData[0] ?
                    newData[0].titleGeneral : ''
            })
            return newData
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleSelectorSpeciality = async (specialty) => {
        showLoading()
        await getLegalMattersByFilter({ page: 1, specialty })
        setDataToFetch({
            category: specialty,
            title: ''
        })
        scroller.scrollTo('myScroll_LegalMatterLanding', { smooth: true, offset: -64 });
        history.push(`${ROUTES.LEGAL_MATTERS}/${specialty}`)
        hideLoading()
    }

    const handleSelectLegalMatter = (legalMatter, id) => {
        showLoading()
        setDataToFetch(legalMatter)
        history.push(`${ROUTES.LEGAL_MATTERS}/${legalMatter.category}/${id}`)
        scroller.scrollTo('myScroll_LegalMatterLanding', { smooth: true, offset: -64 });
        hideLoading()
    }

    const goBack = () => {
        setDataToFetch({
            category: '',
            title: ''
        })
        history.push('/')
    }

    const getLegalMattersWithFilter = filters => { 
        setDataToFetch(filters)
    }

    const handleChangePage = async (event, value) => {
        showLoading()
        let params = { page: value }
        if (dataToFetch && dataToFetch.category) {
            params['specialty'] = dataToFetch.category
        }
        await getLegalMattersByFilter(params)
        setPage(value);
        scroller.scrollTo('myScroll_LegalMatterLanding', { smooth: true, offset: -64 });
        hideLoading()
    };

    function YouTubeGetID(item){
        var videoid = item.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
        if (videoid != null) {
            return videoid[1]
        }
    }

    const onReady = event => {
        event.target.pauseVideo();
    };

    const clickStart = async () => {
        showLoading()
        await getLegalMattersByFilter({ page: 1 })
        setDataToFetch({
            category: '',
            title: ''
        })
        history.push(`${ROUTES.LEGAL_MATTERS}`)
        hideLoading()
    }

    const clickSpecialty = async (specialty) => {
        showLoading()
        await getLegalMattersByFilter({ page: 1, specialty })
        setDataToFetch({
            category: specialty,
            title: ''
        })
        history.push(`${ROUTES.LEGAL_MATTERS}/${specialty}`)
        hideLoading()
    }

    return (
        <ElementScroll name="myScroll_LegalMatterLanding">
            <div className='LegalMatterSectionLanding'>
                {dataToFetch && dataToFetch.category ?
                    <div className='LegalMatterSectionLanding_history'>
                        <HistoryStatesArrows
                            // Pasa setState para el componente
                            filterCategories={getLegalMattersWithFilter}
                            // Pasa state para el componente
                            dataToFilter={dataToFetch}
                            firstWord='Inicio'
                            limitCategory={17}
                            limitTitle={17}
                            // Pasa función opcional para inicio
                            principalFunction={clickStart}
                            // Pasa función opcional para el tipo
                            secondaryFunction={clickSpecialty}
                        />
                    </div> :
                    <div
                        className='LegalMatterSectionLanding_goBack'
                        onClick={goBack}
                    >
                        <img
                            alt='back'
                            src='/img/0-icons-blue-arrow-back.svg'
                            className='LegalMatterSectionLanding_goBack-arrow'
                        />
                        <p className='LegalMatterSectionLanding_goBack-paragraph'>
                            Volver
                        </p>
                    </div>
                }

                {params && params.id ?
                    <div className='LegalMatterSectionLanding_legalUserBox'>
                        <LegalUsersBox
                            title={
                                <h3 className='LegalMatterSectionLanding_legalUserBox-titleContainer'>
                                    Abogados expertos listos para ayudarte con
                                    "<span className='LegalMatterSectionLanding_legalUserBox-title'>{dataToFetch.title}</span>"
                                </h3>
                            }
                            list={
                                legalMatterDetail &&
                                legalMatterDetail[0] &&
                                legalMatterDetail[0].lawyers ?
                                legalMatterDetail[0].lawyers :
                                LAWYERS
                            }
                            buttonTitle={`Ver todos los expertos en ${dataToFetch.title}`}
                            direction={`${ROUTES.SEARCH_LAWYER}especialidad/${dataToFetch.category}`}
                            typeOfUser='lawyer'
                            maxWidth={1167}
                        />
                    </div> :
                    <p className='LegalMatterSectionLanding_title'>
                        Todos los servicios legales que te ofrece Contacta Abogado®
                    </p>
                }

                <div
                    className={
                        legalMatterListByFilter &&
                        legalMatterListByFilter.data &&
                        legalMatterListByFilter.data.length !== 0 ?
                        'LegalMatterSectionLanding_container' :
                        'LegalMatterSectionLanding_containerNoData'
                    }
                >
                    <div className='LegalMatterSectionLanding_dataContainer'>
                        {dataToFetch && dataToFetch.title && isMobile ?
                            <IndexesFromLegalMatters /> : null
                        }
                        {legalMatterDetail &&
                        legalMatterDetail[0] &&
                        dataToFetch &&
                        dataToFetch.title ?
                            <div className='LegalMatterSectionLanding_dataContainer-bodyContainer'>
                                <div className='LegalMatterSectionLanding_dataContainer-body'>
                                    <h1 className='LegalMatterSectionLanding_dataContainer-title'>
                                        {legalMatterDetail[0].titleGeneral}
                                    </h1>
                                    <div
                                        className='LegalMatterSectionLanding_dataContainer-description'
                                        dangerouslySetInnerHTML={{ __html: legalMatterDetail[0].description }}
                                    />
                                </div>
                                {legalMatterDetail[0].titleVideo && legalMatterDetail[0].videoUrl ?
                                    <div className='LegalMatterSectionLanding_dataContainer-youtube'>
                                        <p className='LegalMatterSectionLanding_dataContainer-youtubeTitle'>
                                            {legalMatterDetail[0].titleVideo}
                                        </p>
                                        <Youtube
                                            videoId={YouTubeGetID(legalMatterDetail[0].videoUrl)}
                                            className={classes.youtube}
                                            onReady={onReady}
                                            opts={opts}
                                        />
                                    </div> : null
                                }
                            </div> :
                            <>
                                <Grid
                                    classes={{ root: classes.grid }}
                                >
                                    {legalMatterListByFilter &&
                                    legalMatterListByFilter.data &&
                                    legalMatterListByFilter.data.length !== 0 ?
                                    (legalMatterListByFilter.data.map((elem, index) => {
                                        return (
                                            <LegalMatterCard
                                                key={index}
                                                containerStyle={classes.item}
                                                handleSelectLegalMatter={handleSelectLegalMatter}
                                                legalMatterBody={elem}
                                            />
                                        )
                                    })) : null
                                    }
                                </Grid>
                                {legalMatterListByFilter &&
                                legalMatterListByFilter.data &&
                                legalMatterListByFilter.totalPages &&
                                legalMatterListByFilter.totalPages >= 2 ?
                                    <div className='LegalMatterSectionLanding_pagination'>
                                        <Pagination
                                            color="primary"
                                            page={page}
                                            onChange={handleChangePage}
                                            classes={{ root: classes.pagination }}
                                            count={legalMatterListByFilter.totalPages}
                                        />
                                    </div> : null
                                }
                            </>
                        }
                    </div>
                    <div className='LegalMatterSectionLanding_selectors'>
                        {dataToFetch && dataToFetch.title && !isMobile ?
                            <IndexesFromLegalMatters /> : null
                        }
                        <CategorySelector
                            handleSelectorCategory={handleSelectorSpeciality}
                        />
                    </div>
                </div>
            </div>
        </ElementScroll>
    )
}

const mapStateToProps = state => ({
    legalMatterListByFilter: state.LegalMatterReducer.legalMatterListByFilter,
    legalMatterDetail: state.LegalMatterReducer.legalMatterDetail
})

const mapDispatchToProps = dispatch => ({
    getLegalMattersByFilter:
        params => dispatch(getLegalMattersByFilter(params)),
    getLegalMattersById:
        params => dispatch(getLegalMattersById(params)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading())
})

export default connect(mapStateToProps, mapDispatchToProps)(LegalMattersSection);
